import {Component, inject, Input} from '@angular/core';
import {Sessao} from '../../../../shared/model/sessao/sessao.model';
import {DatePipe} from '@angular/common';
import {environment} from '../../../../../../environments/environment';
import {AuthService} from '../../../../shared/service/auth.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-card-sessao-linha-canal',
  standalone: true,
  imports: [
    DatePipe,
  ],
  templateUrl: './card-sessao-linha-canal.component.html',
  styleUrl: './card-sessao-linha-canal.component.css'
})
export class CardSessaoLinhaCanalComponent {

  @Input() sessao?: Sessao;

  private readonly authService = inject(AuthService);
  private readonly domSanitizer = inject(DomSanitizer);


  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }

}
